import request from "../Requests/requests";
import { removeAllChekList } from "../store/chekListReducer";
import { getCheckList } from "./getCheckList";

export const removAllCheckList = (payload) => {
    return async dispatch => {
        try {
            const response = await request.delete('/Checklist/DeleteSubtasks?TaskId=' + payload)
            dispatch(removeAllChekList(payload))
            dispatch(getCheckList(payload))
            const data = response.data
            return data
        } catch (error) {
            return error
        }  
    }
}